const TERMS = [
  "Tithes & Offerings", "Fund Accounting", "Nested Funds", "Bank Reconciliation", "Split Gifts",
  "Fund Transfers", "Treasurer's Report", "Cleared Balances", "CSV Import", "Nightly Backups",
];

const Cross = () => (
  <svg viewBox="0 0 10 10" className="h-2.5 w-2.5 shrink-0" aria-hidden="true">
    <path d="M5 0v10M2 3.4h6" stroke="#c5a059" strokeWidth="1.4" />
  </svg>
);

export const Marquee = () => (
  <section className="marquee overflow-hidden border-y border-slate-200 bg-white py-6" data-testid="terms-marquee">
    <div className="marquee-track flex w-max items-center">
      {[...TERMS, ...TERMS].map((t, i) => (
        <span key={i} className="flex items-center gap-8 pr-8 font-display text-2xl italic text-navy sm:text-3xl">
          {t}
          <Cross />
        </span>
      ))}
    </div>
  </section>
);
